import { ref } from 'vue'

const isMobileFiltersOpen = ref(false)
const isFlyoutFiltersOpen = ref(false)
const selectedPropertyValues = ref([{ value: 'all', label: 'campaign_subscription_status_all', id: 0 }])
const selectedStatusValues = ref([{ value: 'all', label: 'campaign_subscription_status_all', id: 'all' }])
const selectedFiltersAmount = ref(0)

export function usePremiumProductsFilters() {
  const openMobileFilters = () => {
    isMobileFiltersOpen.value = true
  }
  const closeMobileFilters = () => {
    isMobileFiltersOpen.value = false
  }

  const openFlyoutFilters = () => {
    isFlyoutFiltersOpen.value = true
  }

  const closeFlyoutFilters = () => {
    isFlyoutFiltersOpen.value = false
  }

  return {
    isMobileFiltersOpen,
    openMobileFilters,
    closeMobileFilters,
    selectedPropertyValues,
    selectedStatusValues,
    selectedFiltersAmount,
    isFlyoutFiltersOpen,
    openFlyoutFilters,
    closeFlyoutFilters,
  }
}
